import { COLOR_PALETTE } from 'constants/ui';

export const activeExecutingSpinnerStyles = {
  color: COLOR_PALETTE.BRAND[6],
};

export const inactiveExecutingSpinnerStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const cancelledIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

// DEV-2951: muted glyph for a step the model never ran. Same grey family as
// the cancelled icon so it reads as "inert / didn't happen", distinct from
// the brand-coloured spinner and the green completion check.
export const skippedIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

export const getPendingStyles = size => ({
  width: size,
  height: size,
  borderRadius: '50%',
  border: `2px solid ${COLOR_PALETTE.GRAY[7]}`,
  backgroundColor: 'transparent',
  flexShrink: 0,
});
